

import { TableBody, TableRow, TableCell, Button, IconButton, Grid } from '@material-ui/core'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import PauseIcon from '@mui/icons-material/Pause'
import AssignmentIcon from '@mui/icons-material/Assignment'
import VolumeOffIcon from '@mui/icons-material/VolumeOff'


const ReportTable = ({ classes, callLogs, playPauseCallRecord, playing, handleCallForm, page, rowsPerPage }) => {

    return (
        < >
            <TableBody>
                {callLogs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                    <Grid key={index}>
                        <TableRow
                            style={{
                                borderBottom: '2px solid Black',
                            }}
                        >
                            <TableCell style={{ border: 'none', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                                <Button
                                    style={{ color: 'white', textTransform: 'none', marginLeft: '4px' }}
                                    onClick={() => item.recording !== "" ? playPauseCallRecord(item.recording, index) : null}
                                    disabled={item.recording === ""}
                                >
                                    {item.recording !== "" ? (
                                        playing === index ? <PauseIcon /> : <PlayArrowIcon />
                                    ) : (
                                        <VolumeOffIcon />
                                    )}
                                </Button>
                                <IconButton onClick={() => handleCallForm(item.call_form)}> {/* Move onClick here - Srini - 12/11/24 */}
                                    {Object.keys(item.call_form).length > 0 && (
                                        <AssignmentIcon sx={{ color: "#fff" }} />
                                    )}
                                </IconButton>
                            </TableCell>

                            <TableCell
                                align="left"
                                className={classes.rowtext}
                            >

                                {item.calldatetime?.split(' ')[0]} <br />
                                {item.calldatetime?.split(' ')[1]?.split('.')[0]}
                            </TableCell>

                            <TableCell
                                align="left"
                                className={classes.rowtext}
                            >
                                {item.agentid} <br /> {item.name}
                            </TableCell>

                            <TableCell
                                align="left"
                                className={classes.rowtext}
                            >
                                {item.duration} <br /> {item.billingsec}
                            </TableCell>

                            <TableCell
                                align="left"
                                className={classes.rowtext}
                            >
                                {item.client_number} <br /> {item.call_form?.name}
                            </TableCell>
                            {/* new column - srini - 05/12/24 */}
                            {/* <TableCell align="left" className={classes.rowtext}>
                                {item.call_form && Object.keys(item.call_form).length > 0 ? (
                                    <>
                                        {item.call_form.other ? (
                                            (() => {
                                                const parsedOther = JSON.parse(item.call_form.other)
                                                return (
                                                    <>
                                                        {parsedOther.clientId ? parsedOther.clientId : '-'} <br />
                                                        {parsedOther.custEmail ? parsedOther.custEmail : '-'}
                                                    </>
                                                )
                                            })()
                                        ) : (
                                            '-'
                                        )}
                                    </>
                                ) : (
                                    '-'
                                )}
                            </TableCell> */}
                            {/* Srini - 05/12/24 */}
                            <TableCell
                                align="left"
                                className={classes.rowtext}
                            >
                                {item.call_form?.other?.clientId} <br />
                                {item.call_form?.other?.custEmail} <br />
                            </TableCell>

                            <TableCell
                                align="left"
                                className={classes.rowtext}
                            >
                                {item.call_form?.status}
                            </TableCell>

                            <TableCell
                                align="left"
                                className={classes.rowtext}
                            >
                                {item.call_status === 'Unknown State' ? 'UnAnswered' : item.call_status}
                            </TableCell>

                            <TableCell
                                align="center"
                                className={classes.rowtext}
                            >
                                {item.call_form?.call_description}
                            </TableCell>

                            <TableCell
                                align="center"
                                className={classes.rowtext}
                            >
                                {item.call_form?.comment}
                            </TableCell>

                            <TableCell
                                align="center"
                                className={classes.rowtext}
                            >
                                {item.call_form?.pendingby}
                            </TableCell>

                            <TableCell
                                align="center"
                                className={classes.rowtext}
                            >
                                {item.call_form?.state}
                            </TableCell>

                            <TableCell
                                align="center"
                                className={classes.rowtext}
                            >
                                {item.call_form?.city}
                            </TableCell>

                            <TableCell
                                align="center"
                                className={classes.rowtext}
                            >
                                {item.call_form?.createdby} <br /> {item.call_form?.createdon?.split(' ')[0]}
                            </TableCell>

                            <TableCell
                                align="center"
                                className={classes.rowtext}
                            >
                                {item.call_form?.updatedby} <br /> {item.call_form?.updatedon?.split(' ')[0]}
                            </TableCell>

                            <TableCell
                                align="center"
                                className={classes.rowtext}
                            >
                                {item.call_form?.followup_date} <br /> {item.call_form?.followup_time?.split(' ')[0]}
                            </TableCell>
                        </TableRow>
                    </Grid>
                ))}
            </TableBody>
        </>
    )
}

export default ReportTable